import React, { FC, ReactNode } from "react";

import { SerializedStyles } from "@emotion/react";
import { Text } from "@epignosis_llc/gnosis";
import { t } from "i18next";

import { notificationBannerContainer } from "./styles";

type NotificationBannerProps = {
  variant?: "danger" | "warning";
  title?: string;
  description?: string;
  actions?: ReactNode;
  role?: string;
  ariaLabel?: string;
  ariaLive?: "polite" | "assertive" | "off";
};

const NotificationBanner: FC<NotificationBannerProps> = ({
  variant,
  title,
  description,
  actions,
  role = "banner",
  ariaLabel = t("general.banner"),
  ariaLive = "polite",
}) => {
  return (
    <div
      css={(theme): SerializedStyles => notificationBannerContainer(theme, variant)}
      role={role}
      aria-label={ariaLabel}
      aria-live={ariaLive}
      data-testid="notification-banner-container"
    >
      {title && (
        <Text
          as="div"
          fontSize="xs"
          weight="700"
          data-testid="notification-banner-title"
          className="notification-banner-title"
        >
          {title}
        </Text>
      )}
      {description && (
        <Text
          as="div"
          fontSize="xs"
          data-testid="notification-banner-description"
          className="notification-banner-description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
      {actions && (
        <div data-testid="notification-banner-actions" className="notification-banner-actions">
          {actions}
        </div>
      )}
    </div>
  );
};

export default NotificationBanner;
